/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { KeyValueIntegerString } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ritorna la lista dei tipi fascicolo
 * @summary Lista tipi fascicolo
 */
export const getTipiFascicoli = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<KeyValueIntegerString[]>(
    {
      url: `/framework-cfg-procedimenti/tipi-fascicoli`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiFascicoliQueryKey = () =>
  [`/framework-cfg-procedimenti/tipi-fascicoli`] as const;

export const getGetTipiFascicoliQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiFascicoli>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiFascicoli>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiFascicoli>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipiFascicoliQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiFascicoli>>
  > = ({ signal }) => getTipiFascicoli(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiFascicoliQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiFascicoli>>
>;
export type GetTipiFascicoliQueryError = ErrorType<unknown>;

/**
 * @summary Lista tipi fascicolo
 */
export const useGetTipiFascicoli = <
  TData = Awaited<ReturnType<typeof getTipiFascicoli>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiFascicoli>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiFascicoliQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
